import { render, staticRenderFns } from "./SetWholesaleDoc.vue?vue&type=template&id=b37229fe&"
import script from "./SetWholesaleDoc.vue?vue&type=script&lang=js&"
export * from "./SetWholesaleDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
